const roles = {
    green: ['вип', 'премиум', 'креатив', 'админ', 'зам. создателя'],
    orange: ['игрок', 'модератор', 'оператор', 'анти-грифер', 'консоль', 'ст.администратор'],
    aqua: ['флай', 'стажер'],
    pink: ['ультра', 'лорд', 'легенда', 'санта', 'граф', 'купидон'],
    blue: ['хелпер', 'бог', 'властелин', 'спонсор', 'создатель', 'помощник'],
    red: ['титан', 'администратор']
}

export default {
    methods: {
        matchRoleToColor(role) {
            role = role.toLowerCase();
            const color = Object.keys(roles).find((key)=>roles[key].includes(role));
            return color || 'gray';
        }
    }
}
